import db from './db';

export function normalizeWidgetRuntimeTitle(title) {
  return typeof title === 'string' ? title.replace(/\s+/g, ' ').trim() : '';
}

export async function storeWidgetRuntimeTitle({ workspaceId, widgetId, title }) {
  const normalizedTitle = normalizeWidgetRuntimeTitle(title);
  if (!workspaceId || !widgetId || !normalizedTitle) return;

  await db.widget_runtime_titles.put({
    workspace_id: workspaceId,
    widget_id: widgetId,
    title: normalizedTitle,
    updated_at: Date.now(),
  });
}
